/*
 * Copyright (c) 2024-2026 Nodals AI Ltd
 * All rights reserved.
 */

import { Logger } from '../../../logger';
import { ensureStringArray } from '../../../util';

import type { WeboramaConfig } from '../../../types/vendor/weborama';

const logger = Logger.getInstance();

const DEFAULT_STORAGE_KEY: string = 'webo_wam2gam_entry';

class WeboramaFacts {
  static get(config: WeboramaConfig): string[] {
    if (config?.enabled !== false) {
      if (config?.cohorts && Array.isArray(config.cohorts)) {
        return config.cohorts.map(String);
      }
      const localStorageKey = config?.storageKey ?? DEFAULT_STORAGE_KEY;
      const entry = localStorage.getItem(localStorageKey);
      if (entry) {
        logger.debug('Weborama cohort data located in local storage.');
        try {
          const data = JSON.parse(entry);
          const weboAudiences = ensureStringArray(data.targeting.webo_audiences);
          const webo_cs = ensureStringArray(data.targeting.webo_cs);
          return [...weboAudiences, ...webo_cs];
        } catch (error) {
          logger.warn(`Error extracting Weborama data: ${error}`);
        }
      }
    }
    return [];
  }
}

export { WeboramaFacts };
